import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "description" }

import { computed,inject } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SectionHeader',
  props: [`title`,`text`],
  setup(__props) {


const displayWidth:any=inject(`displayWidth`)

const computedDisplayWidth = computed(() => {
  return displayWidth.value < 700
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([`sectionHeader`,{modileSectionHeader: computedDisplayWidth.value},])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.title), 1)
    ]),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.text), 1)
  ], 2))
}
}

})